export const getProduct = (productId) => ({ products }) =>
  products.productsList.find(({ id }) => id === productId);
